import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cy-popup full-height full-width"
}
const _hoisted_2 = { class: "q-mx-auto width-fit q-pa-md text-center" }

import { computed } from "vue";
import { appStore, timStore, projectStore } from "@/hooks";
import { navigateTo, Routes } from "@/router";
import { PanelCard, TextButton } from "@/components/common";


/**
 * Renders options for creating a project or artifact when the graph is empty.
 */
const __default__ = {
  name: "EmptyGraphButtons",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const displayPopup = computed(
  () => !appStore.isLoading && timStore.artifactTypes.length === 0
);

return (_ctx: any,_cache: any) => {
  return (displayPopup.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(projectStore).isProjectDefined)
            ? (_openBlock(), _createBlock(_unref(PanelCard), {
                key: 0,
                title: "Welcome to SAFA!",
                subtitle: "Create an artifact to get started."
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TextButton), {
                    text: "",
                    icon: "add",
                    label: "Create Artifact",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(appStore).openDetailsPanel('saveArtifact')))
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_unref(PanelCard), {
                key: 1,
                title: "Welcome to SAFA!",
                subtitle: "Create a project to get started."
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TextButton), {
                    text: "",
                    icon: "add",
                    label: "Create Project",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(navigateTo)(_unref(Routes).PROJECT_CREATOR)))
                  })
                ]),
                _: 1
              }))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})